// Course Section model based on API::V1::Section::InteractiveSerializer
export default {

  // Relationships
  global_slide: {
    jsonApi: 'hasOne',
    type: 'global_slides'
  }
}
